/**
 * Created by Roman on 2015-03-26.
 */

interface ISectionSetup {
    isActive: boolean;
    name: string;
    title: string;
}

class SectionsController {

    registry: ISectionSetup[] = [];
    onActiveSectionChange: Function;

    setup(sections: ISectionSetup[], onActiveSectionChange) {
        this.registry = sections;
        this.onActiveSectionChange = onActiveSectionChange;
    }

    activate(section: ISectionSetup | string) {
        if (typeof section === "string") {
            section = this.registry.filter(rs => rs.name === section)[0];
        }
        this.registry.forEach(rs => rs.isActive = false);
        section.isActive = true;

        if (this.onActiveSectionChange) this.onActiveSectionChange(section);
    }

    isActive(sectionName) : boolean {
        const sections = this.registry ? this.registry.filter(rs => rs.name === sectionName) : [];
        return sections.length > 0 ? sections[0].isActive : false;
    }
}

angular.module('fliptoWeb')
    .directive('ftSections', [function () {

        return {
            scope: false,
            controller: SectionsController,
            controllerAs: "$ftSections",
            bindToController: true,
            require: "ftSections",
            link: function SectionsLinkFn(scope, elem, attrs, ctrl) {
                scope.$watch(() => scope.$eval(attrs.hasOwnProperty("ftSections") ? attrs.ftSections : attrs.registry), (val) => ctrl.setup(val, scope.$eval(attrs.onactivesectionchange)), true);
            }
        };
    }])
    .directive('ftSection', [function () {

        return {
            scope: true,
            transclude: true,
            template: `
                <ng-transclude ng-if="$ftSection.isActive"></ng-transclude>
            `,
            link: function SectionLinkFn(scope, elem, attrs, ctrl) {
                scope.$watch(() => scope.$ftSections && scope.$ftSections.registry && scope.$ftSections.registry.find(section => section.name === (attrs.ftSection || attrs.name)), (section) => {
                    scope.$ftSection = section;
                }, true);
            }
        };
    }])
    .directive('ftSectionTrigger', [function () {

        return {
            scope: false,
            require: "^ftSections",
            link: function SectionTriggerLinkFn(scope, elem, attrs, ctrl) {

                function setActive() {
                    scope.$apply(() => {
                        ctrl.activate(attrs.ftSectionTrigger);
                    });
                }

                elem.bind("click", setActive);

                scope.$on("$destroy", () => {
                    elem.unbind("click", setActive);
                });
            }
        };
    }]);